"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ContentService =
/*#__PURE__*/
function () {
  function ContentService() {
    _classCallCheck(this, ContentService);

    this.endpoint = null;

    this.parse = function () {
      return null;
    };

    this.verifyParams = function () {
      return false;
    };

    this.getCustomHeaders = function () {};

    this.params = {};
    this.token = null;
  }

  _createClass(ContentService, [{
    key: "isParamExludedFromQuery",
    value: function isParamExludedFromQuery(param) {
      return param === 'isReady';
    }
    /**
     *
     * @param {Object<string,string>} params
     * @param {string} token
     */

  }, {
    key: "loadWithParamsAndToken",
    value: function loadWithParamsAndToken() {
      var _this = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var token = arguments.length > 1 ? arguments[1] : undefined;
      this.params = params;
      this.token = token;
      return new Promise(function (resolve, reject) {
        if (!_this.endpoint) {
          reject(new Error("No endpoint set for ".concat(_this.constructor.name)));
          return;
        }

        if (!_this.token) {
          reject(new Error("No token set for ".concat(_this.constructor.name)));
          return;
        }

        if (!_this.verifyParams()) {
          reject(new Error("Invalid params set for ".concat(_this.constructor.name, " - Params: ").concat(Object.keys(_this.params))));
          return;
        }

        _this.doQuery().then(function (response) {
          if (response && response.status === 200 && response.data) {
            var parsedData = _this.parse(response.data) || response.data;

            if (parsedData) {
              resolve(parsedData);
            } else {
              reject(new Error("Content not parsable - endpoint: ".concat(_this.endpoint, " service: ").concat(_this.constructor.name)));
            }
          } else {
            reject(new Error("ContentLoader::An error occured loading content from endpoint - ".concat(_this.endpoint, " - ").concat(response.status)));
          }
        })["catch"](function (reason) {
          reject(reason);
        });
      });
    }
  }, {
    key: "doQuery",
    value: function doQuery() {
      var _this2 = this;

      return _axios["default"].get(this.endpoint, {
        params: this.params,
        paramsSerializer: function paramsSerializer(params) {
          var out = [];
          var keys = Object.keys(params);
          keys.forEach(function (key) {
            if (!_this2.isParamExludedFromQuery(key)) {
              if (params[key]) {
                if (params[key] && params[key] instanceof Array) {
                  params[key].forEach(function (value) {
                    out.push("".concat(key, "=").concat(value));
                  });
                } else {
                  out.push("".concat(key, "=").concat(params[key]));
                }
              }
            }
          });
          return out.join('&');
        },
        headers: _objectSpread({}, {
          Authorization: "Bearer ".concat(this.token),
          'Content-Type': 'application/json'
        }, {}, this.getCustomHeaders())
      });
    }
  }]);

  return ContentService;
}();

var _default = ContentService;
exports["default"] = _default;